import React, { Component } from 'react'
import { Link, useHistory } from 'react-router-dom';
import api from '../../services/api';
import DataTable from 'react-data-table-component';
import { toast } from 'react-toastify';
import Loading from '../../common/Loading'

class Grupo extends Component {

    constructor(props){
        super(props);

        this.state = {
            items: [],
            filtros:[],
            itensRow:[],
            isListagem:true,
            isEdicao: false,
            id:'',          
            nome:'',
            permissao:''
            
        }

        this.add = this.add.bind(this);
        this.edit = this.edit.bind(this);
        this.save = this.save.bind(this);
        this.delete = this.delete.bind(this);
        this.cancel = this.cancel.bind(this);
        this.atualiza = this.atualiza.bind(this);
        this.handleFiltroGrid = this.handleFiltroGrid.bind(this);

    }

    async Loading(isLoading) {
        this.setState({ isLoading: isLoading });
    }

    async componentDidMount() {
        const token    = sessionStorage.getItem('token');
        const grupo     = sessionStorage.getItem('grupo');       
        this.Loading(true)
        const permissoes = await api.get(`/api/permissao/${grupo}`, {
            headers: {
                'x-access-token':token,
            }
        });       

        const empresaGrupo        = permissoes.data.filter(function(value){ return value.idmenu  == 15 })
        if(empresaGrupo.length > 0 && empresaGrupo[0].permissao.indexOf('VER') < 0 ) return this.props.history.push('/index') 
        
        
        await api.get('/api/gruposervico', {
            headers: {
                'x-access-token':token,
            }
        }).then(response => {  
            this.Loading(false)         
            this.setState( { items : response.data, filtros: response.data} );
        })
        this.Loading(false)
    }

    add = async(item) => {

           
        const token    = sessionStorage.getItem('token');        
        const grupo     = sessionStorage.getItem('grupo');       
        
        const permissoes = await api.get(`/api/permissao/${grupo}`, {
            headers: {
                'x-access-token':token,
            }
        });       

        const empresaGrupo        = permissoes.data.filter(function(value){ return value.idmenu  == 15 })
        if(empresaGrupo.length > 0 && empresaGrupo[0].permissao.indexOf('INSERIR') < 0 ) return toast.error('O usuário sem permissão.') 
   
        
        this.setState({
            isListagem: false, 
            isEdicao:true,
            id:'',           
            nome:'',           
        })

    }

    edit = async( id ) => {
        
        const grupo     = sessionStorage.getItem('grupo');       
        const token    = sessionStorage.getItem('token');
        
        const permissoes = await api.get(`/api/permissao/${grupo}`, {
            headers: {
                'x-access-token':token,
            }
        });       

        const empresaGrupo        = permissoes.data.filter(function(value){ return value.idmenu  == 15 })
        if(empresaGrupo.length > 0 && empresaGrupo[0].permissao.indexOf('ALTERAR') < 0 ) return toast.error('O usuário sem permissão.') 
     
        
        try {
            await api.get(`/api/gruposervico/${id}`, {
                headers: {
                    'x-access-token':token,
                }
            }).then(response => {
                this.setState({
                    isListagem: false, 
                    isEdicao:true,
                    id:response.data.id,
                    nome:response.data.nome,                   
                })      
            });

        } catch (error) {
            this.alert(error)       
        }
    }

    cancel = (item) => {
        const token    = sessionStorage.getItem('token');
       
        api.get('/api/servico', {
            headers: {
                'x-access-token':token,
            }
        }).then(response => {           
            this.setState({
                isListagem: true, 
                isEdicao:false,
                id:'',
                nome:'',
                items : response.data    
            })
        })     

    }

    save = async (event) => {
        event.preventDefault();
        const { id, nome, tipo } = this.state
        const grupo     = sessionStorage.getItem('grupo');       
        const token    = sessionStorage.getItem('token');
        
        const permissoes = await api.get(`/api/permissao/${grupo}`, {
            headers: {
                'x-access-token':token,
            }
        });       

        const empresaGrupo        = permissoes.data.filter(function(value){ return  value.idmenu  == 15 })
     //   if( id && empresaGrupo[0].permissao.indexOf('ALTERAR') < 0 ) return toast.error('O usuário sem permissão.') 
      //  if( !id && empresaGrupo[0].permissao.indexOf('INSERIR') < 0 ) return toast.error('O usuário sem permissão.') 
        
        
        try {
            
            if ( id ) {
     
                if(empresaGrupo.length > 0 && empresaGrupo[0].permissao.indexOf('ALTERAR') < 0 ) return toast.error('O usuário sem permissão.') 
     
        
                await api.put(`/api/gruposervico/${id}`,{ nome }, {
                    headers: {
                        'x-access-token':token,
                    }
                }).then(response => {
                    api.get('/api/gruposervico', {
                        headers: {
                            'x-access-token':token,
                        }
                    }).then(response => {           
                        toast.success("Registro salvo.");                        
                        this.setState({
                            isListagem: true, 
                            isEdicao:false,
                            id:'',
                            nome:'',                          
                            items : response.data
                
                        });
                       
                    })
                })
            } else {
                if(empresaGrupo.length > 0 && empresaGrupo[0].permissao.indexOf('INSERIR') < 0 ) return toast.error('O usuário sem permissão.') 
     
                await api.post('/api/gruposervico',{ id, nome, tipo }, {
                    headers: {
                        'x-access-token':token,
                    }
                }).then( async response => {
                    const grupo = response.data.id
                    await api.get('/api/gruposervico', {
                        headers: {
                            'x-access-token':token,
                        }
                    }).then(response => {           
                        toast.success("Registro salvo.");                        
                        
                        this.setState({
                            isListagem: true, 
                            isEdicao:false,
                            id:'',
                            nome:'',
                            items : response.data
                
                        });
                    })
                   
                })
            }
        } catch (error) {
            toast.error(error)            
        }
        
    }

    delete = async (id) => {

        const grupo     = sessionStorage.getItem('grupo');       
        const token    = sessionStorage.getItem('token');
        
        const permissoes = await api.get(`/api/permissao/${grupo}`, {
            headers: {
                'x-access-token':token,
            }
        });       

        const empresaGrupo        = permissoes.data.filter(function(value){ return  value.idmenu  == 15 })
        if( empresaGrupo.length > 0 && empresaGrupo[0].permissao.indexOf('EXCLUIR') < 0 ) return toast.error('O usuário sem permissão.') 
        
        
        try {
            
            if ( window.confirm(`Confirma deleção do registro ${id}?`)) {
            
                await api.delete(`/api/gruposervico/${id}`, {
                    headers: {
                        'x-access-token':token,
                    }
                }).then(response => {
                    api.get('/api/gruposervico', {
                        headers: {
                            'x-access-token':token,
                        }
                    }).then(response => {
                        this.setState( { items : response.data } );
                        toast.error(<i class="fas fa-trash-alt nav-icon"> Registro Excluído Com Sucesso!</i>)
                    });
                });
            }
        } catch (error) {
            toast.error("Ocorreu um erro ao tentar excluisr o registro.")       
        }
    }
    
    atualiza = async() => {

        const token    = sessionStorage.getItem('token');
       
        await api.get('/api/gruposervico', {
            headers: {
                'x-access-token':token,
            }
        }).then(response => {           
            this.setState({
                isListagem: true, 
                isEdicao:false,
                id:'',
                nome:'',               
                items : response.data    
            })
        })
    }

    handleFiltroGrid = async (filterText) => {
        const { filtros, items } = this.state;
        this.Loading(true);
        const filtragem =
          filterText.length > 0
            ? items.filter((item) =>
                (
                  item.id +
                  "" +
                  item.nome 
                )
                  .toLowerCase()
                  .includes(filterText.toLowerCase())
              )
            : filtros;
        this.setState({ items: filtragem, filterText: filterText });
    
        this.Loading(false);
    };
    
    render() {

        const subHeaderComponentMemo = (
            <div class="card-tools">
              <div class="input-group input-group-sm">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Pesquisar"
                  onChange={(e) => this.handleFiltroGrid(e.target.value)}
                />
                <div class="input-group-append">
                  <div class="btn btn-primary">
                    <i class="fas fa-search"></i>
                  </div>
                </div>
              </div>
            </div>
          );

        const columns = [
            {
              name: 'Id',
              selector: 'id',
              sortable: true,
            },
            {
              name: 'Nome',
              selector: 'nome',
              sortable: true,
            }, 
           
            {
                name: 'Editar',
                selector: 'Editar',
                cell: row =>   <div class="btn-group">
                                  <button id="editar" className="btn btn-default" onClick={ () => { this.edit(row.id)}}><i class="fa fa-edit"></i></button>
                                  <button id="excluir" className="btn btn-danger" onClick={ () => { this.delete(row.id)}}><i class="fas fa-trash-alt"></i></button>                                                           
                              </div>,
                button: true,
            }
        ];
        const {items,isListagem, isEdicao} = this.state;
    
        return ( 
            <div className="wrapper">
                <div className="content-wrapper">
                    <section className="content-header">
                           
                        <div className="card">
                            <div className="card-header">
                                <h3 className="card-title"><i className="fas fa-address-book"></i> CADASTRO GRUPO SERVIÇOS</h3>

                                <div className="card-tools">
                                    <button type="button" className="btn btn-tool" data-card-widget="Atualizar" data-toggle="Atualizar" title="Atualizar" onClick={ () => this.atualiza() }>
                                        <i className="fas fa-sync"></i>
                                    </button>
                                
                                    <button type="button" className="btn btn-tool" data-card-widget="Minimizar" data-toggle="Minimizar" title="Minimizar">
                                        <i className="fas fa-minus"></i>
                                    </button>
                                
                                </div>
                            </div>
                            <div className="card-body">
                        
                                <div className="card card-primary card-outline card-tabs">
                                    <div className="card-header p-0 pt-1 border-bottom-0">
                                        <ul className="nav nav-tabs" id="custom-tabs-two-tab" role="tablist">
                                            <li className="nav-item">
                                                <a className={ isListagem ? "nav-link active" : "nav-link" } id="custom-tabs-listagem-dados-tab" data-toggle="pill" onClick={ () => this.cancel } href="#custom-tabs-listagem-dados" role="tab" aria-controls="custom-tabs-listagem-dados" aria-selected={ isListagem ? true : false }>Listagem</a>
                                            </li>
                                            <li className="nav-item">
                                                <a className={ isEdicao   ? 'nav-link active' : 'nav-link' } id="custom-tabs-edicao-dados-tab" data-toggle="pill" onClick={() => this.add } href="#custom-tabs-edicao-dados" role="tab" aria-controls="custom-tabs-edicao-dados" aria-selected={isEdicao ? true : false }>Edição</a>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="card-body">
                                        <div className="tab-content" id="custom-tabs-two-tabContent">
                                            <div className={ isListagem ? "tab-pane fade show active" : "tab-pane fade"} id="custom-tabs-listagem-dados" role="tabpanel" aria-labelledby="custom-tabs-listagem-dados-tab">
                                                <DataTable
                                                    title="Listar"
                                                    columns={columns}
                                                    data={items}
                                                    pagination
                                                    subHeader
                                                    subHeaderComponent={subHeaderComponentMemo}
                                                />
                                                <button type="button" onClick={ this.add } className="btn btn-info pull-right">Novo</button>
                                               
                                            </div>
                                            <div className={ isEdicao ? "tab-pane fade show active" : "tab-pane fade"} id="custom-tabs-edicao-dados" role="tabpanel" aria-labelledby="custom-tabs-edicao-dados-tab">
                                                <form onSubmit={ this.save }>
                                                    <div className="form-group">
                                                        <label>ID</label>
                                                        <input type="text" className="form-control" name="id" placeholder="ID do Registro" value={ this.state.id } onChange={ e => this.setState({ id: e.target.value})} readOnly/>
                                                    </div>
                                                                                                       
                                                    <div className="form-group">
                                                        <label>Nome</label>
                                                        <input type="text" className="form-control" name="nome" placeholder="Nome do Registro" value={ this.state.nome } onChange={ e => this.setState({ nome: e.target.value})} required/>
                                                    </div>
                                                    
                                                    <button type="submit" className="btn btn-success pull-right">Salvar</button>
                                                    <button type="button" className="btn btn-danger pull-right" onClick={ this.cancel }>Cancelar</button>
                                                </form>
                                            </div>                                        
                                        </div>
                                    </div>
                                </div>
                            </div> 
                            <div className="card-footer">                        
                            </div>
                            <Loading isCarrega={ this.state.isLoading } />
                        </div>
                    </section>
                </div>
            </div>
        )
    }
        
}

export default Grupo;